<template>
  <div class="flex flex-col gap-1 rounded-lg border border-violet-200 bg-violet-50/60 px-3 py-2 text-sm">
    <div class="flex flex-wrap items-center gap-x-4 gap-y-1">
      <button v-if="poNumber" type="button" class="font-semibold text-gray-900 hover:text-blue-700 hover:underline" @click="emit('open-po')">{{ poNumber }}</button>
      <b class="whitespace-nowrap text-gray-900">Ship by {{ fmtDay(shipBy) }}</b>
      <span class="whitespace-nowrap tabular-nums text-gray-600">{{ fmtPcs(toPlan) }} pcs to plan</span>
      <span class="flex-1"></span>
      <button v-if="canWithdraw" type="button" class="btn-secondary btn-sm" :disabled="withdrawing" @click="emit('withdraw')">
        {{ withdrawing ? 'Withdrawing…' : 'Withdraw' }}
      </button>
      <button v-if="canAnswer" type="button" class="btn-primary btn-sm" :disabled="answering" data-return-focus="answer" @click="emit('answer')">Answer</button>
    </div>
    <p v-if="note" class="m-0 break-words text-gray-700">{{ note }}</p>
    <p v-if="requestedAt" class="m-0 text-xs text-gray-500">
      {{ requestAgeText(requestedAt, isoToday()) }}
      <template v-if="requestedBy">· requested by {{ requestedBy }}</template>
    </p>
  </div>
</template>

<script setup lang="ts">
  import { fmtDay, fmtPcs, isoToday, requestAgeText } from '@/utils/poTracker';

  // poNumber is set in the open-requests list, where the line has to name its PO.
  withDefaults(
    defineProps<{
      shipBy: string;
      toPlan: number;
      poNumber?: string | null;
      note?: string | null;
      requestedAt?: string | null;
      requestedBy?: string | null;
      canWithdraw?: boolean;
      canAnswer?: boolean;
      answering?: boolean;
      withdrawing?: boolean;
    }>(),
    { poNumber: null, note: null, requestedAt: null, requestedBy: null, canWithdraw: false, canAnswer: false, answering: false, withdrawing: false }
  );
  const emit = defineEmits<{ 'open-po': []; withdraw: []; answer: [] }>();
</script>
